import * as React from "react";
const SvgSelectDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.99998 9.87879L12.7123 6.1665L13.773 7.22716L8.99998 12.0002L4.22705 7.22716L5.28771 6.1665L8.99998 9.87879Z", fill: "#666666", style: {
  fill: "#666666",
  fill: "color(display-p3 0.4000 0.4000 0.4000)",
  fillOpacity: 1
} }));
export default SvgSelectDown;
